import { render, staticRenderFns } from "./editClasses.vue?vue&type=template&id=4bd3bd8c"
import script from "./editClasses.vue?vue&type=script&lang=js"
export * from "./editClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports